import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { getRuntimeConfig } from "../../Lib/Config/RuntimeConfig";
import { apiRequest, geoSearchApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IDistanceResponse } from "../../Orchestrator/Types/Interface/IDistance";
import { IGeocodeSearchResponse } from "../../Orchestrator/Types/Interface/IGeoSearch";

export async function fmlmSearchLocation(query: string): Promise<IApiResponse<IGeocodeSearchResponse>> {
  const ENDPOINTS = await getEndpoints();
  const language = await getLocaleFromCookie();

  const endpoint = `${ENDPOINTS.fmlmSearchLocation}?q=${query}&country=AE&lang=${language}`;
  return apiRequest<IGeocodeSearchResponse>(endpoint, "GET");
}

export async function fmlmReverseGeocode(
  longitude: number,
  latitude: number
): Promise<IApiResponse<any>> {
  const ENDPOINTS = await getEndpoints();
  const language = await getLocaleFromCookie();

  const endpoint = `${ENDPOINTS.fmlmReverseGeocode}?longitude=${longitude}&latitude=${latitude}&language=${language}`;
  return apiRequest<any>(endpoint, "GET");
}

export async function fmlmCalculateDistance(coordinates: string): Promise<IApiResponse<IDistanceResponse>> {
  const ENDPOINTS = await getEndpoints();

  let queryParams = new URLSearchParams({
    sources: "0",
    annotations: "distance,duration",
  });

  const endpoint = `${ENDPOINTS.fmlmCalculateDistance}/${coordinates}?${queryParams.toString()}`;
  const response = await fetch(endpoint);
  const data = await response.json();
  return {
    status: response.status === 200 ? "ok" : "ko",
    code: response.status,
    answer: data,
  };
}

export async function fmlmViewInformation(data: any, showLoader: boolean = true): Promise<IApiResponse<any>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = `${ENDPOINTS.fmlmViewInformation}`;
  const config = await getRuntimeConfig();
  return apiRequest<any>(endpoint, "POST", {
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      "x-vibe-api-key": config.AXONVIBE_API_KEY,
    },
  }, "none", undefined, undefined, showLoader);
}
